const flightTypePrefix = "experiment/FLIGHTS/";
const flightActionTypes = {
  LOAD_FLIGHTS: `${flightTypePrefix}LOAD_FLIGHTS`,
  LOADING_FLIGHTS: `${flightTypePrefix}LOADING_FLIGHTS`,
  LOADED_FLIGHTS: `${flightTypePrefix}LOADED_FLIGHTS`,
  LOAD_FLIGHT: `${flightTypePrefix}LOAD_FLIGHT`,
  LOADING_FLIGHT: `${flightTypePrefix}LOADING_FLIGHT`,
  LOADED_FLIGHT: `${flightTypePrefix}LOADED_FLIGHT`
};
const loadFlights = (id, workspaceId, managementGroup, flights) => {
  return {
    id,
    type: flightActionTypes.LOAD_FLIGHTS,
    payload: {
      id,
      workspaceId,
      managementGroup,
      flights
    },
    error: null
  };
};
const loadingFlights = (id) => {
  return {
    id,
    type: flightActionTypes.LOADING_FLIGHTS,
    payload: {
      id
    },
    error: null
  };
};
const loadedFlights = (id, error = null) => {
  return {
    id,
    type: flightActionTypes.LOADED_FLIGHTS,
    error
  };
};
const loadingFlight = (id, name) => {
  return {
    id,
    type: flightActionTypes.LOADING_FLIGHT,
    payload: {
      name
    }
  };
};
const loadedFlight = (id, name, flight, error = null) => {
  return {
    id,
    type: flightActionTypes.LOADED_FLIGHT,
    payload: {
      flight
    },
    name,
    // @ts-ignore
    error
  };
};
export {
  flightActionTypes,
  flightTypePrefix,
  loadFlights,
  loadedFlight,
  loadedFlights,
  loadingFlight,
  loadingFlights
};
//# sourceMappingURL=Flights.ducks.js.map
